export default __webpack_public_path__ + "3162e4c.png";